module.exports = __webpack_public_path__ + "static/media/logo_mindwell.516d57a8.svg";